// The app's top-level module tabs (Home, Customer, Sales, ...), in nav
// order. Lives here — not in App.js — so screens that need it (e.g.
// ScreenSettingsTable's module-number legend) can import it without
// creating a circular dependency with App.js itself. New modules are
// appended, never inserted/reordered — manualScreenController.js's
// MODULE_ORDER assigns each module's number by key (not by this array's
// position), specifically so a screen's reference code never shifts.
export const MODULE_TABS = [
  { key: 'home', label: 'Home' },
  { key: 'sales', label: 'Sales' },
  { key: 'purchasing', label: 'Purchasing' },
  { key: 'inventory', label: 'Inventory' },
  { key: 'accounting', label: 'Accounting' },
  { key: 'global', label: 'Platform' },
  { key: 'crm', label: 'CRM' },
  { key: 'market-intel', label: 'Market Intel' },
  { key: 'warehouse', label: 'Warehouse' },
  { key: 'receivables', label: 'Receivables' },
];

// The frontend's own copy of manualScreenController.js's MODULE_ORDER —
// can't be imported across the backend/frontend boundary, so kept here in
// sync by hand. This, not MODULE_TABS' array position, is the actual
// module number a screen gets assigned (position stopped matching number
// once the old "Customer" module — number 2 — was removed without a
// placeholder, permanently retiring that number). Any consumer that needs
// to go from a module to its number (or vice versa) must use this map, not
// a MODULE_TABS array index.
export const MODULE_NUMBER_BY_KEY = {
  home: 1,
  sales: 3,
  purchasing: 4,
  inventory: 5,
  accounting: 6,
  global: 7,
  crm: 8,
  'market-intel': 9,
  warehouse: 10,
  receivables: 11,
};

// Module switcher for the left icon rail, top to bottom. Kept separate
// from MODULE_TABS (and freely reorderable) since other consumers — the
// module-number legend — depend on that list's original order instead.
export const MODULE_RAIL = [
  { key: 'crm', label: 'CRM', moduleKey: 'crm' },
  { key: 'sales', label: 'Sales', moduleKey: 'sales' },
  { key: 'warehouse', label: 'Warehouse', moduleKey: 'warehouse' },
  { key: 'purchasing', label: 'Purchasing', moduleKey: 'purchasing' },
  { key: 'inventory', label: 'Inventory', moduleKey: 'inventory' },
  { key: 'receivables', label: 'Receivables', moduleKey: 'receivables' },
  { key: 'accounting', label: 'Accounting', moduleKey: 'accounting' },
  { key: 'market-intel', label: 'Market Intel', moduleKey: 'market-intel' },
  { key: 'global', label: 'Platform', moduleKey: 'global' },
];
